import React from 'react';

function ProfileIcon({ iconClass }) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" fill="#fff" stroke='currentColor' strokeWidth={1} width='1em' height='1em' viewBox="0 0 44.43 44.43" className={iconClass}><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><path class="cls-1" d="M35.49,33a10.44,10.44,0,0,1-8-4.65,4.16,4.16,0,0,1,.75-5.12,14.07,14.07,0,0,0,4.1-10.31C32.29,5.8,27.73,0,22.12,0S12,5.8,12,12.92a14.08,14.08,0,0,0,4.1,10.32,4.15,4.15,0,0,1,.75,5.11,10.45,10.45,0,0,1-8,4.65A8.75,8.75,0,0,0,0,41.75v2.68H44.24V41.75A8.76,8.76,0,0,0,35.49,33Z" /></g></g></svg >
    );
}

export default ProfileIcon;